module.exports = __webpack_public_path__ + "static/base-8-657f1de8a54ec4d483a95bd3561b2c10.jpg";